import { useTranslation } from 'react-i18next';

import { OppvarmingFormData } from '../../../types';

export const useGassValidation = () => {
  const { t } = useTranslation();
  const validateGassSelection = (_: boolean, { gass }: OppvarmingFormData) => {
    const anySelected = gass?.value?.kamin?.selected || gass?.value?.kjel?.selected;

    if (!anySelected) {
      return t('form.oppvarming.gass.error');
    }
    return true;
  };
  return { validateGassSelection };
};
